import { parseCookies } from "nookies";

export function getCookie(key: string){
    const COOKIES = parseCookies()
    const SOMECOOKIE = COOKIES[key]
    return SOMECOOKIE
}